<template>
  <div>
    <div class="media-mtx-list">
      <template v-for="(stream) in streams">
        <div class="media-mtx-list-item" style="padding: 8px;">
          <k-layout>
            
            <k-flex c4 style="overflow: hidden;">
              <span v-tooltip.top="`Stream name:<br>${stream.name}`">{{get_channel_title(stream)}}</span>
            </k-flex>
            
            <k-flex c2>
              <k-chip v-tooltip.top="get_source_tooltip(stream)" small :color="get_source_color(stream)">
                <template v-if="!is_source_pull(stream)">
                  <span class="text-uppercase">{{get_source_type(stream)}}</span>: {{get_source_ip(stream)}}
                </template>
                <template v-else>
                  <span class="text-uppercase">{{get_source_type(stream)}} PULL</span>
                </template>
              </k-chip>
            </k-flex>
            
            <k-flex c5>
              <k-chip v-for="reader in get_readers(stream)" :key="reader.id" v-tooltip.top="`Bytes sent: ${get_dest_stats(reader)}`" small :color="get_dest_color(reader)">
                <span class="text-uppercase">{{get_dest_type(reader)}}</span>: {{get_dest_ip(reader)}}
              </k-chip>
            </k-flex>
            
            <k-flex c1>
              <k-btn color="danger" icon icon-name="refresh" @click="kick_stream(stream)" v-if="!is_source_pull(stream)"></k-btn>
              <k-btn color="danger" icon icon-name="delete" @click="remove_pull(stream)" v-if="is_source_pull(stream)"></k-btn>
            </k-flex>
            
          </k-layout>
        </div>
        <k-divider></k-divider>
      </template>
    </div>
  </div>
</template>

<script>

import datelib from '@/lib/date.js';
import moment from 'moment';
import ChannelModel from '@/models/channel.js';
import InstanceModel from '@/models/instance.js'

export default {
  props: ["id", "stats"],
  methods: {
    get_source_tooltip(stream) {
      let html = '';
      if (!this.is_source_pull(stream)) {
        html += `<div class="mb-1"><div class="font-weight-bold">Bytes received:</div>${this.get_source_stats(stream)}</div>`;
      } else {
        html += `<div class="mb-1"><div class="font-weight-bold">Url:</div>${this.get_source_url(stream)}</div>`;
      }
      html += `<div class="font-weight-bold">Tracks:</div>`;
      for (let track of this.get_tracks(stream)) {
        html += `<div>${track}</div>`;
      }
      return html;
    },
    get_readers(stream) {
      return _.get(stream, "readers", []);
    },
    get_source_type(stream) {
      return _.get(stream, "source.type", "").replace("Conn", "").replace("Source", "");
    },
    get_source_ip(stream) {
      return _.get(stream, "source.remoteAddr", "").split(":")[0]
    },
    get_source_color(stream) {
      if(stream.confName != "all" && _.get(stream, "ready", false)) return "success";
      if(_.get(stream, "source.state", "init") == "publish" && _.get(stream, "ready", false)) return "success";
      return "warning";
    },
    get_source_stats(stream) {
      return _.get(stream, "source.bytesReceived", "");
    },
    get_source_url(stream) {
      return _.get(stream, "source.url", "");
    },
    is_source_pull(stream) {
      return _.get(stream, "confName", "") != "all" || _.get(stream, "source.pull", false);
    },
    get_dest_type(dest) {
      return _.get(dest, "type", "").replace("Conn", "");
    },
    get_dest_ip(dest) {
      var ip = _.get(dest, "remoteAddr", "").split(":")[0];
      return _.get(dest, "remoteAddr", "").split(":")[0];
    },
    get_dest_color(dest) {
      if(_.get(dest, "state", "init") == "read") return "success";
      return "warning";
    },
    get_dest_stats(dest) {
      return _.get(dest, "bytesSent", "");
    },
    get_tracks(stream) {
      return _.get(stream, "tracks", []);
    },
    get_start_time(stream) {
      return moment(_.get(stream, "readyTime", ""), "YYYY-MM-DDTHH:mm:ss.SSSSSSZZ").format("DD.MM.YYYY HH:mm");
    },
    is_ready(stream) {
      return true
    },
    get_channel_title(stream) {
      var channel = _.find(this.$store.state.channels, (channel) => { return channel.name == _.get(stream, "name", ""); });
      return _.get(channel, "title");
    },
    kick_stream(stream) {
      var type = this.get_source_type(stream)
      var id = _.get(stream,"source.id");
      if(id) {
        InstanceModel.mediamtx_kick(InstanceModel.get_instance(this.id), id, type, () => {}, () => {});
      }
    },
    remove_pull(stream) {
      InstanceModel.mediamtx_remove_pull(InstanceModel.get_instance(this.id), stream.name, () => {}, () => {});
    }
  },
  computed: {
    streams() {
      return _.get(this.stats, "mtx_streams")
    }
  }
}
</script>
<style lang="css" scoped>

</style>